import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, SearchTipoMovimientoRequest, SaveTipoMovimientoDto, TipoMovimiento, TipoMovimientoEnum } from "../model/index";
import { SharedFunctions } from '../shared.functions';

@Injectable({
  providedIn: 'root'
})
export class TipoMovimientoService extends CrudService<TipoMovimiento, number, SaveTipoMovimientoDto, SearchTipoMovimientoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'tipomovimiento', sharedFunctions);
  }
  
  getTipos(): Observable<GenericResponse<TipoMovimientoEnum[]>> {
    return this._http.get<GenericResponse<TipoMovimientoEnum[]>>(this._serviceUrl + '/tipos-enum', this.httpOptions);
  }
}
